const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import YXXTableModuleBase from "../table/yxx_table_module_base";
import CpTableView from "./cp_table_view";
import CpTableModel from "./cp_table_model";
import AppData from "../../../public/const/app_data";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import { YXXGame } from "../../net/proto/yxx_proto_game";
import { YXXRoom } from "../../net/proto/yxx_proto_room";
import ModelData from "../../../public/model_data";
import UserDataManager from "../../../../manager/user_manager";
import EventManager from "../../../../manager/event_manager";
import { joinUtil } from "../../../public/join_util";

@ccclass
@moduleInit("CpTableModule")
export default class CpTableModule extends YXXTableModuleBase<CpTableView, CpTableModel>  {

    protected m_selectedBetArea: number = -1

    constructor() {
        super()
        this.windowPrefabResPath = 'package/yxx/cp_table';
        this.betNameList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        this.viewType = CpTableView;
        this.modelType = CpTableModel;
    }

    isMyBanker: boolean = false

    protected m_is_first_choose_jetton: boolean = true
    onModuleInit() {
    }

    onShow(intentData) {
        super.onShow(intentData);        
        this.currentBetType = null
    }

    protected onButtonClickName(name: string) {
        super.onButtonClickName(name)
        if( name == "Player7"){
            this.model.request_online_players()
        }                
    }

    protected onButtonClick(obj: cc.Node) {
        if (obj.parent == this.view.betObj || obj.parent == this.view.betOther) {
            this.view.showChooseJetton(obj, true)
        }
        else if (obj.parent.name == "BetArea") {
            let area = Number(obj.name)
            let result = this.isBet(area)
            if(result){
                //押注后取消勾选自动押注
                if (this.isAutoBet){
                    this.updateIsAutoBet()
                }
                if (this.view.autoBetBtn.enabled == true){
                    this.setAutoBtnStatus(this.BtnStatus.Gray)
                }
            }
           
        }
        else if (obj.parent.name == "Players"){
            this.clickPlayIcon(obj)
        }
        else {

        }
    }

    //点击自动下注
    onAutoBetClick(isBet, isAuto){
        if (!isBet || this.lastRoundBetData == null){ return }
        let count = 0
        let oldType = this.currentBetType
        //重新计算一遍是为了 在押注了别的后 再点续压
        for (const key in this.lastRoundBetData) {
            if (this.lastRoundBetData.hasOwnProperty(key)) {
                const areaDatas = this.lastRoundBetData[key];
                for (const iterator of areaDatas) {
                    count += iterator
                }
            }
        }
        if (count <= this.myRoleData.balance){
            for (const key in this.lastRoundBetData) {
                if (this.lastRoundBetData.hasOwnProperty(key)) {
                    const areaDatas = this.lastRoundBetData[key];
                    for (const iterator of areaDatas) {
                        if (iterator != this.currentBetType){
                            this.currentBetType = iterator
                        }
                        this.isBet(Number(key), true)
                    }
                }
            }
        }
        else{
            if (isAuto){
                ModuleManager.instance.toastKey("lhd_tipsNoAutoBet")
            }
        }
        this.setAutoBtnStatus(this.BtnStatus.NoneGray)
        this.currentBetType = null
        this.view.curChooseJetton = null
        this.view.showChooseJetton(null)
    }

    // protected on_click_jetton(obj: cc.Node){
    //     this.currentBetType = this.view.jettonItemBtns[obj.name].Count
    //     return this.do_bet(this.m_selectedBetArea, this.isAutoBet)
    // }
        
    //更新玩家信息 一般 结算的时候 或者刚进入
    updatePlayerInfo(roomInfo: YXXRoom.RoomInfo) {
        if (roomInfo.players == null) { return }
        let playerDatas = roomInfo.players
        this.view.isShowPlayerIndex = []
        for (const data of playerDatas) {
            let isUpdate = true //本次是否更新数据
            let isMySelf = ModelData.instance.roleData.id == Number(data.id)
            if (isMySelf){
                this.myRoleData = data
                this.currentGold = 0
                isUpdate = false
                if (!this.roomStatus || roomInfo.state == 7) {
                    this.myGold = Number(data.balance)
                    isUpdate = true
                    this.aotuChooseBetBtn()
                    this.view.updateJettonMask(this.myGold - this.retainCount, roomInfo.state != 5)                    
                    UserDataManager.balanceChangeMessage(this.myGold)
                }

            }
            UserDataManager.setUserGameTableCurrency(Number(data.id), Number(data.balance))
            this.view.updatePlayerInfo(data, isUpdate, isMySelf)
        }

        if (playerDatas.length < this.view.selfPosIndex) {
            this.view.hidePlayerItem()
        }
        if(roomInfo.state != 5){
            this.m_selectedBetArea = null            
        }
    }

    //点击自动下注
    // onAutoBetClick(isBet, isAuto){
    //     if (!isBet || this.lastRoundBetData == null){ return }
    //     let count = 0
    //     let oldType = this.currentBetType
    //     //重新计算一遍是为了 在押注了别的后 再点续压
    //     for (const key in this.lastRoundBetData) {
    //         if (this.lastRoundBetData.hasOwnProperty(key)) {
    //             const areaDatas = this.lastRoundBetData[key];
    //             for (const iterator of areaDatas) {
    //                 count += iterator
    //             }
    //         }
    //     }
    //     if (count <= this.myRoleData.balance){
    //         for (const key in this.lastRoundBetData) {
    //             if (this.lastRoundBetData.hasOwnProperty(key)) {
    //                 const areaDatas = this.lastRoundBetData[key];
    //                 for (const iterator of areaDatas) {
    //                     if (iterator != this.currentBetType){
    //                         this.currentBetType = iterator
    //                     }
    //                     this.do_bet(Number(key), true)
    //                 }
    //             }
    //         }
    //     }
    //     else{
    //         if (isAuto){
    //             ModuleManager.instance.toastKey("lhd_tipsNoAutoBet")
    //         }
    //     }
    //     this.setAutoBtnStatus(this.BtnStatus.NoneGray)
    // }

    // protected do_bet(area: number, isAuto:boolean = false): boolean{
    //     if (this.currentRanker != null && this.currentRanker.id == this.myRoleData.id){
    //         return
    //     }

    //     if (this.roomStatus != 5 || !this.isCanBet) {
    //        // ModuleManager.instance.toast(LanguageManager.t("server_error_-205"))
    //         return false
    //     }
    //     if(area <= 0){
    //         this.view.playAreaFlicker()
    //         return true
    //     }
    //     if (this.currentBetType == null) {
    //         ModuleManager.instance.toastKey("lhd_qxzyz");
    //         return true
    //     }

    //     if (this.roomStatus == 7) {
    //         ModuleManager.instance.toastKey("lhd_zzkjshyz")
    //         return true
    //     }

    //     if ((this.myGold - this.currentBetType - this.retainCount) < 0){
    //         ModuleManager.instance.toastKey("server_error_-41")
    //         return
    //     }



        
    //     this.localBetIndex += 1
    //     this.myGold -= this.currentBetType
    //     this.view.playBetSelfAmin(this.currentBetType, area, this.localBetIndex, this.myGold)
    //     this.model.request_bet(area, this.currentBetType)
    //     //续压模块
    //     if (!isAuto){
    //         for (const key in this.lastRoundBetData) {
    //             if (Number(key) == area &&  this.lastRoundBetData.hasOwnProperty(key) ) {
    //                 const areaDatas = this.lastRoundBetData[key];
    //                 for (let index = 0; index < areaDatas.length; index++) {
    //                     if (areaDatas[index] == this.currentBetType){
    //                         areaDatas.splice(index,1)
    //                         break
    //                     }
                        
    //                 }
    //             }
    //         }
    //     }
    //     this.aotuChooseBetBtn()
    //     this.view.updateJettonMask(this.myGold - this.retainCount, false)
    //     return true
    // }

    isBet(area: number, isAuto:boolean = false): boolean {
        if(this.roomStatus != 5){
            return
        }
        if(!this.isCanBet){
            return
        }
        if (this.currentBetType == null) {
            this.view.flickerJettons()
            joinUtil.showRechargeInMultiple(this);
            return false
        }
                
        if (this.currentRanker != null && this.currentRanker.id == this.myRoleData.id){
            return
        }

        if (this.roomStatus != 5 || !this.isCanBet) {
           // ModuleManager.instance.toast(LanguageManager.t("server_error_-205"))
            return false
        }

        if (this.roomStatus == 7) {
            ModuleManager.instance.toastKey("lhd_zzkjshyz")
            return false
        }

        if ((this.myGold - this.currentBetType - this.retainCount) < 0){
            ModuleManager.instance.toastKey("server_error_-41")
            return
        }


        this.view.refreshSelectArea(area)
        
        this.localBetIndex += 1
        this.myGold -= this.currentBetType
        this.view.playBetSelfAmin(this.currentBetType, area, this.localBetIndex, this.myGold)
        this.model.request_bet(area, this.currentBetType)
        //续压模块
        if (!isAuto){
            for (const key in this.lastRoundBetData) {
                if (Number(key) == area &&  this.lastRoundBetData.hasOwnProperty(key) ) {
                    const areaDatas = this.lastRoundBetData[key];
                    for (let index = 0; index < areaDatas.length; index++) {
                        if (areaDatas[index] == this.currentBetType){
                            areaDatas.splice(index,1)
                            break
                        }
                        
                    }
                }
            }
        }
        this.aotuChooseBetBtn()
        this.view.updateJettonMask(this.myGold - this.retainCount, this.roomStatus != 5)
        return true
    }

    on_refresh_result_history(protoData: YXXGame.IBetResultHistory){
        let self = this
        if (self.twentyTimesResult == null){
            this.view.roadMapView.showPanel(protoData.result, false)
        }
        self.twentyTimesResult = protoData.result
        
    }

    changeCaiChi(){

    }

    //设置续压按钮的状态
    setAutoBtnStatus(statusType){
        if(this.isMyBanker || !this.canAutoBet()){
            statusType = this.BtnStatus.Gray
        }
        switch(statusType){
            case this.BtnStatus.None:
                this.view.autoBetBtn.enabled = true
                this.view.autoBetBtn.interactable = true
                Utility.setNodeGray(this.view.autoBetBtn.node, false)
                this.view.autoBetBtn.node.opacity = 255
                break;
            case this.BtnStatus.Gray:
            case this.BtnStatus.NoneGray:
                this.view.autoBetBtn.enabled = false
                this.view.autoBetBtn.interactable = false
                this.view.autoBetBtn.node.opacity = 255
                Utility.setNodeGray(this.view.autoBetBtn.node, true)
                break;
            default:
                break;
        }
    }

    canAutoBet(){
        if(!this.lastRoundBetData){
            return false
        }
        let total = 0
        for (const key in this.lastRoundBetData) {
            if (this.lastRoundBetData.hasOwnProperty(key)) {
                const element = this.lastRoundBetData[key];
                for (const key in element) {
                    if (element.hasOwnProperty(key)) {
                        total += Number(key)
                    }
                }
                
            }
        }
        return total < this.myGold - this.retainCount
    }

    onMsgBankerInfo(protoData: YXXGame.IBankerInfo){
        let self = this
        self.currentRanker = protoData.banker
        if (protoData.isPlayer){
            self.view.updateBanker(protoData.banker.id, protoData)
            let isWaitBanker = true
            let myIsBanker = self.currentRanker.id == self.myRoleData.id
            
            this.view.nodeInputMask.active = !!myIsBanker
            // self.view.betBtnNode.active = !myIsBanker
            // self.view.betObj.active = !myIsBanker
           
            this.setAutoBtnStatus( (myIsBanker) ? this.BtnStatus.Gray : this.curBtnStatus)
            self.view.updateJettonMask(self.myGold - self.retainCount, this.roomStatus != 5, !!myIsBanker)
            
            if (myIsBanker && protoData.banker.round >= self.rule.pub_BeDealerMin){
                isWaitBanker = false
            }
            self.view.updateBankerBtn(!myIsBanker, !isWaitBanker)
            this.isMyBanker = myIsBanker
        }
        else{    
            this.isMyBanker = false   
            this.view.nodeInputMask.active = false  
            self.view.lastBankerId = null
            // self.view.betBtnNode.active = true
            // self.view.betObj.active = true
            this.setAutoBtnStatus( (this.curBtnStatus == this.BtnStatus.None) ? this.BtnStatus.NoneGray : this.curBtnStatus)
            self.view.updateJettonMask(self.myGold - self.retainCount, this.roomStatus != 5)
            self.view.updateBanker(0, null)
            self.view.updateBankerBtn(true, false)
        }
    }



    //处理新的押注数据
    disPoseNewBetData(betData: YXXGame.IBetBroadCast) {
        if (betData.newData == null || betData.newData.length <= 0) { return }
        if (betData.playersBetData == null) { return }
        let otherBetData = betData.newData
        let isPlaying = false
        for (const value of betData.playersBetData) {
            if (value.data != null) {
                isPlaying = value.id != this.myRoleData.id
                this.view.playBetAmin(value, value.id == this.myRoleData.id, otherBetData)
            }
        }

        if (isPlaying) {
            // this.view.tableSound.playBet(false)
        }

        this.view.playOtherBetAmin(otherBetData, true, isPlaying)
    }

    
    aotuChooseBetBtn() {
        if(!this.m_is_first_choose_jetton){
            return
        }
        this.m_is_first_choose_jetton = false
        if (this.myRoleData == null) { return }
        let canBetCount = this.myGold -  this.retainCount
        if (this.currentBetType != null){
            if (this.currentBetType > canBetCount){
                
                let objItemData = null
                for (const key in this.view.jettonItemBtns) {
                    if (this.view.jettonItemBtns.hasOwnProperty(key)) {
                        const element = this.view.jettonItemBtns[key];
                        if (element.Count <= canBetCount){
                            objItemData = element
                        }
                    }
                }
                if (objItemData != null){ 
                    this.view.showChooseJetton(objItemData.BtnObj.node)
                }
                else{
                    this.currentBetType = null
                    this.view.showChooseJetton(null)
                }
            }
        }
        else{
            const element = this.view.jettonItemBtns["1"];
            if (element.Count <= canBetCount){
                this.view.showChooseJetton(element.BtnObj.node)
            }
        }
    }

     //房间信息得改变
    //     STARTING = 0,      -- 开始
    //   SHUFFLING = 1,    -- 洗牌
    //   READY = 2,      -- 准备
    //   DEAL = 3,      -- 发牌
    //   BETTING = 4,      -- 下注
    //   TURN = 5,      -- 开牌
    //   SETTLE = 6,      -- 派奖
    changeRoomInfo(roomData: YXXRoom.RoomInfo) {
        if(this.roomStatus == null){
            this.roomStatus = 0
            this.eventDispatch('Game_Table_Start');
        }
        let self = this
        switch (roomData.state) {
            case 3: // 准备
                this.setLastRoundBetData() 
                this.isFristBetAim = true
                this.localBetIndex = 0
                this.betIndex = 0
                this.initBetData = null
                this.autoBetOver = false
                this.view.cleanTable()
                this.view.playReadyAmin(this.roomStatus != null)
                this.eventDispatch('Game_Table_Start');
                break
            case 5: //下注
                //this.isCanBet = true
                if (this.isFristBetAim) {
                    if (self.roomStatus != null){
                        this.view.showBetTips(true)
                    }
                    let tempTime = this.roomStatus == null ? 0 : 2
                    self.scheduleOnce(function () {
                        self.isCanBet = true
                        self.setAutoBtnStatus(self.curBtnStatus)
                        self.view.updateJettonMask(self.myGold - self.retainCount, false)
                        self.showBetTime(roomData.betTimeout - tempTime, true)
                    }, tempTime)
                    self.isFristBetAim = false
                }
                self.updatePlayerInfo(roomData)
                break
            case 6: //开牌
                this.setAutoBtnStatus( (this.curBtnStatus == this.BtnStatus.None) ? this.BtnStatus.NoneGray : this.curBtnStatus)
                self.isCanBet = false
                self.updatePlayerInfo(roomData)
                if (this.roomStatus != null) {
                    this.view.showResulet(this.currentResult, function () {
                        EventManager.instance.dispatch("event_update_betresulthistory", self.twentyTimesResult)
                    })
                }
                break
            case 7: //派奖
                self.updatePlayerInfo(roomData)
                if (self.initBetData != null){
                    self.view.playResultAmin(this.currentResult, self.initBetData.totalData, self.JackpotDataAdd) //
                    self.JackpotDataAdd = 0
                }
                self.scheduleOnce(function () {
                    self.changeCaiChi()
                }, 1)
                break
            default:
                break;
        }
        if (!this.roomStatus) {
            self.updatePlayerInfo(roomData)
        }
        this.roomStatus = roomData.state
    }
}